import { getAllLocations, getPortfolios } from '@lms/api-client/backend';
import { LoaderCircle } from 'lucide-react';
import useSWR from 'swr';
import { useSiteAccess } from '@/features/auth/use-auth';
import { useBrand } from '@/features/branding/brand-provider';
import { SuperStats } from '@/features/dashboard/components/superstats';
import { NotFound } from '@/routes/not-found';

// Ports app/[brand]/admin/superstats/page.tsx. The Next page loaded all
// locations server-side and relied on the backend to reject non-super-admins;
// here the super-admin gate comes from `useSiteAccess` (matching the demo
// route), the locations load via SWR, and the SPA passes their ids to
// `SuperStats`. Renders content only; the admin <Shell> is provided by the
// route tree.
export function Superstats() {
  const { slug } = useBrand();
  const { access, loading: roleLoading } = useSiteAccess(slug);
  const isSuperAdmin = access?.superAdmin ?? false;

  const { data: locations } = useSWR(
    isSuperAdmin ? ['admin/all-locations'] : null,
    () => getAllLocations(),
  );
  const { data: portfolios } = useSWR(
    isSuperAdmin ? ['admin/portfolios'] : null,
    () => getPortfolios(),
  );

  if (roleLoading) {
    return (
      <div className="flex h-full items-center justify-center py-16">
        <LoaderCircle className="text-primary size-12 animate-spin" />
      </div>
    );
  }

  if (!isSuperAdmin) {
    return <NotFound />;
  }

  return (
    <div>
      <SuperStats
        locations={(locations ?? []).map(({ id }) => id)}
        customers={portfolios?.length ?? 0}
      />
    </div>
  );
}
